import { MessageBar, MessageBarBody, MessageBarIntent, MessageBarTitle } from '@fluentui/react-components';
import { ReactNode } from 'react';
import { ItemList, TDisplayItem } from './ItemList';

const CustomMessageBar = ({
  intent,
  multi,
  title,
  body,
  items,
  children,
}: {
  intent?: MessageBarIntent;
  multi?: boolean;
  title?: string;
  body: ReactNode;
  items?: TDisplayItem[];
  children?: ReactNode;
}) => {
  return (
    <div className="space-y-1">
      <MessageBar intent={intent || 'error'} layout={multi ? 'multiline' : 'singleline'}>
        <MessageBarBody>
          {title && <MessageBarTitle>{title}</MessageBarTitle>}
          <span>{body}</span>
        </MessageBarBody>
      </MessageBar>
      {items && items.length > 0 && <ItemList displayItems={items} isSideBar={false} />}
      {children}
    </div>
  );
};

export { CustomMessageBar };
